















































import { Vue, Component, Prop, Provide } from "vue-property-decorator";
import { goBack } from "@/NavigationHelper";

@Component
export default class BemerkungAnwesenheiten extends Vue {
  private showLoading: boolean = false;

  private initalized: boolean = false;

  public mounted() {
    this.showLoading = true;
  }
}
